import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed} from 'vue';
import ContentTab from "~/chat/vue/widget/tabs/ContentTab.vue";
import {IWidgetTabParams, TAB_TYPE_HTML} from "~/chat/ts/data/ITab";
import {ConfigStore} from "~/chat/ts/store/Config";


const __default__ = {
    name: "OfflineHtmlContent"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let tab = computed<IWidgetTabParams>(() => {
    return {
        type: TAB_TYPE_HTML,
        title: ConfigStore.siteParams.value.params.leadGen.tabTitle,
        content: {
            html: ConfigStore.siteParams.value.params.leadGen.yourOfflineHTML
        },
        visible: 1,
        id: "offline_html_content",
        weight: 0
    };
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContentTab, {
    tab: _unref(tab),
    "use-default-close-handler": ""
  }, null, 8, ["tab"]))
}
}

})